import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ConfiguratorRenewalAction } from '@models';
import { GetRenewalActionsParams } from './service';

export enum GetRenewalActionsActions {
  Failure = '[Configurator GetRenewalActions] Failure',
  Request = '[Configurator GetRenewalActions] Request',
  Success = '[Configurator GetRenewalActions] Success',
}

export const GetRenewalActionsFailure = createAction(
  GetRenewalActionsActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const GetRenewalActionsRequest = createAction(
  GetRenewalActionsActions.Request,
  props<{ parameters?: GetRenewalActionsParams }>()
);

export const GetRenewalActionsSuccess = createAction(
  GetRenewalActionsActions.Success,
  props<{ data: ConfiguratorRenewalAction[] }>()
);
